import {useNavigate} from "react-router-dom";

export default function useGoToNavigation() {
    const navigate = useNavigate();

    // 내부수정: 새창으로열리기 new tab 추가
    const goToNavigation = (
        url: string | -1 | number,
        state: {},
        isTrue: boolean,
        options?: { newTab?: boolean }
    ) => {
        if (typeof url === "number") {
            navigate(url);
            return;
        }
        const fullUrl = process.env.PUBLIC_URL + "/" + url;
        
        if (options?.newTab) {
            window.open(fullUrl, "_blank");
            return;
        }
        navigate(fullUrl, {
            state,
            replace: isTrue,
        });
    };
    /*
    const goToNavigation = (url: string | -1 | number, state: {}, isTrue: boolean) => {
        if (typeof url === "number") {
            navigate(url)
        } else {
            navigate(process.env.PUBLIC_URL + "/" + url, {
                state,
                replace: isTrue,
            });
        }
    };
    */
    return {goToNavigation};
}